import i18n, { t } from 'i18next'

import { TPlan, TTranslationSchema } from '@/config/types'
import { Languages, isLanguage } from '@/enums/languages'

export const plans: Array<TPlan> = []

const getDurationString = (
  interval: string,
  intervalCount: number,
  delimiter: string = ' '
): string => {
  const ending = t('paymentScreenPage.receiptData.periods.ending', { defaultValue: '' })
  const plural = t(`paymentScreenPage.receiptData.periodsPlural.${interval}`, { defaultValue: '' })
  const singular = t(`paymentScreenPage.receiptData.periods.${interval}`, { defaultValue: '' })
  const intervalText = intervalCount > 1 && plural ? plural : singular

  return `${intervalCount}${delimiter}${intervalText}${intervalCount > 1 ? `${ending}` : ''}`
}

const translateBackendData = (data: TTranslationSchema | undefined): string => {
  if (!data) {
    return ''
  }

  const lng: Languages = isLanguage(i18n.resolvedLanguage) ? i18n.resolvedLanguage : Languages.EN

  return data[lng] || ''
}

for (const planDetails of window.config.PLANS.sort((a, b) => a.order - b.order)) {
  const plan: TPlan = {
    planId: `plan_${planDetails.planInternalId}`,
    preselected: planDetails.preselected,
    internalPlanId: planDetails.planInternalId,
    payPalPlanId: planDetails.paypalPlanId,
    trialName: planDetails.trialPriceAmount
      ? `${getDurationString(planDetails.trialInterval, planDetails.trialIntervalCount)} trial`
      : '',
    trialPrice: +planDetails.trialPriceAmount,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    name: translateBackendData(planDetails.name),
    discountPercentage: planDetails.discountPercentage,
    periodPrice: +planDetails.periodPrice,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    periodLabel: translateBackendData(planDetails.periodLabel),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    totalPeriodLabel: translateBackendData(planDetails.totalPeriodLabel),
    crossedPrice: +planDetails.crossedPrice,
    //optional?
    crossedPeriodPrice: planDetails.crossedPeriodPrice
      ? +planDetails.crossedPeriodPrice
      : undefined,
    price: +planDetails.basePriceAmount,
    overrideMainPrice: planDetails.overrideMainPrice,
    duration: getDurationString(planDetails.interval, planDetails.intervalCount),
    trialDuration: getDurationString(planDetails.trialInterval, planDetails.trialIntervalCount),
    currencySign: '$',
    currency: planDetails.currency,
    renewEvery: getDurationString(planDetails.interval, planDetails.intervalCount, '-'),
    renewAfter: planDetails.trialPriceAmount
      ? getDurationString(planDetails.trialInterval, planDetails.trialIntervalCount, '-')
      : '',

    orderPlanName: `${planDetails.intervalCount}-${planDetails.interval.toLowerCase()}`,
    orderPlanNameVerbose: `${planDetails.intervalCount}-${planDetails.interval.toLowerCase()} plan`,

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    extraTop: translateBackendData(planDetails.accentPrimary),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    title: translateBackendData(planDetails.title),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    tag: translateBackendData(planDetails.tag),
    hasTrial: function () {
      return !isNaN(this.trialPrice)
    },
    extraDiscountPlan: planDetails.extraDiscountPlan || false,
  }

  plans.push(plan)
}
